import { Box, Divider } from "@outschool/backpack";
import { ClassDetailsNoSectionsQuery } from "@outschool/gql-frontend-generated";
import { LazyBox } from "@outschool/ui-components-shared";
import {
  CurvedGradientSection,
  Loading,
} from "@outschool/ui-legacy-component-library";
import React from "react";

import RecentlyViewListingCarousel from "../../listings/carousels/RecentlyViewListingCarousel";
import { MoreSameTeacherListingCarousel } from "./MoreSameTeacherListingCarousel";
import { ParentsAlsoLikeList } from "./ParentsAlsoLikedList";
import { RelatedCategories } from "./RelatedCategories";
import { TeacherSuggestList } from "./TeacherSuggestList";

type MobileBelowClassDetailProps = {
  otherListingsRef: React.MutableRefObject<null>;
  activity: ClassDetailsNoSectionsQuery["activity"];
  leader: NonNullable<ClassDetailsNoSectionsQuery["activity"]["leader"]>;
};
export const MobileBelowClassDetail = ({
  otherListingsRef,
  activity,
  leader,
}: MobileBelowClassDetailProps) => {
  const CARROUSEL_ROW_NUM = 0;

  return (
    <CurvedGradientSection>
      <Box
        ref={otherListingsRef}
        sx={{
          minHeight: "500px",
          padding: "3rem 0",
        }}
      >
        <TeacherSuggestList activity={activity} leader={leader} />

        <MoreSameTeacherListingCarousel
          teacherName={leader.name || ""}
          carouselRowNum={CARROUSEL_ROW_NUM}
          activity={activity}
        />

        <RecentlyViewListingCarousel
          carouselRowNum={CARROUSEL_ROW_NUM}
          activity={activity}
        />

        <RelatedCategories activity={activity} />
        <Divider sx={{ borderColor: "gray100", marginTop: "2.4rem" }} />

        <LazyBox placeholder={<Loading />} rootMargin="150px 0px">
          <ParentsAlsoLikeList activity={activity} />
        </LazyBox>
      </Box>
    </CurvedGradientSection>
  );
};
